import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const braintrust = defineConnector({
  identifier: "braintrust",
  name: "Braintrust",
  tagLine: "Evals and observability for AI apps",
  logo,
  protocol: "http",
  tags: ["ai", "engineering", "observability"],
  defaultUrlPattern: () => "https://api\\.braintrust\\.dev/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Braintrust](https://www.braintrust.dev/app/~/configuration/org/api-keys), open **Configuration › API keys** and create a new key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.braintrust.dev/v1/project?limit=1",
  },
});
